function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "12",
  height: "12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M2.647 7.81L7.81 2.645a.5.5 0 01.706 0l.838.838a.5.5 0 010 .707L4.191 9.353a.498.498 0 01-.353.147H2.5V8.162c0-.132.053-.259.147-.353z",
  stroke: "#6E6F70",
  strokeWidth: ".75",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.875 3.58L8.42 5.125",
  stroke: "#6E6F70",
  strokeWidth: ".75",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));